declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export interface GTMEventParams {
  [key: string]: any;
}

/**
 * Отправляет кастомное событие в Google Tag Manager (dataLayer).
 *
 * @param event - имя события (например "page_view", "purchase", "subs_shown")
 * @param params - дополнительные параметры события
 */
export const pushToDataLayer = (
  event: string,
  params: GTMEventParams = {},
): void => {
  if (typeof window === 'undefined') return; // SSR / безопасность
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...params,
  });
};
